export const GET_YLF_PRODUCTS_SUCCESS = "GET_YLF_PRODUCTS_SUCCESS";
export const GET_YLF_PRODUCTS_FAILURE = "GET_YLF_PRODUCTS_FAILURE";

export const REGISTER_YLF_SUCCESS = "REGISTER_YLF_SUCCESS";
export const REGISTER_YLF_FAILURE = "REGISTER_YLF_FAILURE";
